module.exports = __webpack_public_path__ + "images/aristo/slider_handles.png";